export default "__VITE_ASSET__987c6d73__"